import { CRUISES_API } from '../misc/consts';

export default (cruiseId, itinCode) => ({
  showAll: false,
  dates: [],

  init() {
    this.fetchDates();
  },

  async fetchDates() {
    const ietfLanguageTag = document.documentElement.getAttribute('data-lang');
    const params = {
      cruise: cruiseId,
      itin: itinCode,
    };
    const queryString = new URLSearchParams(params).toString();

    try {
      const response = await fetch(`${CRUISES_API}/dates?${queryString}`, {
        headers: {
          'Accept-Language': ietfLanguageTag,
        },
      });

      if (response.ok) {
        const data = await response.json();
        this.dates = data.data;
      }
    } catch (error) {
      this.handleFetchError(error);
    }
  },

  filteredDates() {
    if (this.showAll) {
      return this.dates;
    }

    let ret = [];

    this.dates.forEach((item, index) => {
      if (item.near_by || index === 0) {
        ret.push(item);
      }
    });
    return ret;
  },

  getUrl(currentUrl, cruiseId) {
    console.log(currentUrl, cruiseId);
  },

  handleFetchError(error) {
    if (error.name !== 'AbortError') {
      console.error('Error:', error);
    }
  },
});
